export const defaultLimitSearch = { page: 1, limit: 10 };
export const defaultLimitSearchLite = { page: 1, limit: 10 };
